<!--
 * @Description: 客户账号详情-合同信息
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-03-15 18:07:25
 * @LastEditors: cxh
-->
<template>
  <a-form>
    <DetailCard
      v-for="(item, index) in data"
      :key="index"
      :columns="columns"
      :title="`${t('contract.concatMessage')}${index + 1}`"
      :data="item"
    >
      <template #subTitle>
        <dc-layout-button-group>
          <a-button type="primary" @click="viewPdf(item)">{{ t('btn.originalpreview') }}</a-button>
          <a-button @click="showEditModal(item)">{{ t('btn.changeContractCode') }}</a-button>
        </dc-layout-button-group>
      </template>
    </DetailCard>
    <dc-layout-empty type="nothing" v-if="!data || !data.length" />
  </a-form>
  <cos-footer-button :loading="loading" :returnName="returnName" :hideOk="true" />
  <cos-modal
    v-model:visible="visible"
    :title="t('contract.changeContractCodeModalTitle')"
    width="470px"
    @ok="updateCode"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item
        name="contractCode"
        :label="t('contract.oldConcatCode')"
        :rules="[{ required: true, message: t('common.pleaseInput') }]"
      >
        <CosInput v-model:value="editForm.contractCode" :disabled="true" />
      </a-form-item>
      <a-form-item
        name="newContractCode"
        :label="t('contract.newConcatCode')"
        :rules="[{ required: true, message: t('common.pleaseInput') }]"
      >
        <CosInput v-model:value="editForm.newContractCode" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref, computed, onMounted } from 'vue'
import DetailCard from '@/components/DetailCard'
import { queryContractDetail, contractCodeUpdate } from '@/api/overseasSales/customerCenter'
import { useRoute } from 'vue-router'
import { DcMessage } from '@dc-platform/dc-components'
import type { ContractItem } from '@/typings/api/customerCenter'
import { useI18n } from 'vue-i18n'
export default { name: 'tabsContract ' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const route = useRoute()
defineProps({
  returnName: String
})
const visible = ref(false)
const formRef = ref()
const loading = ref(false)
const editForm = ref<ContractItem>({})
const data = ref<ContractItem[]>([])
const columns = computed(() => [
  { title: t('contract.customerName'), dataIndex: 'customerName' },
  { title: t('contract.arkCode'), dataIndex: 'arkCode' },
  { title: t('contract.id'), dataIndex: 'id' },
  { title: t('contract.contractCode'), dataIndex: 'contractCode' },
  { title: t('contract.contractBusiness'), dataIndex: 'contractBusiness' },
  {
    title: t('contract.serviceSubject'),
    dataIndex: 'serviceSubject',
    node: 'ParamCodesSelect',
    attrs: {
      paramCode: 'ofbu_service_body',
      appId: 'cos_ofbu',
      view: true
    }
  },
  { title: t('contract.contractType'), dataIndex: 'contractType' },
  { title: t('contract.offlineSyncTime'), dataIndex: 'offlineSyncTime' },
  { title: t('contract.businessThirdCate'), dataIndex: 'businessThirdCate' },
  { title: t('contract.contactName'), dataIndex: 'contactName' },
  { title: t('contract.contactMobile'), dataIndex: 'contactMobile' },
  { title: t('contract.contactEmail'), dataIndex: 'contactEmail' },
  { title: t('contract.counterpartContactName'), dataIndex: 'counterpartContactName' },
  { title: t('contract.counterpartContactMobile'), dataIndex: 'counterpartContactMobile' },
  { title: t('contract.counterpartContactEmail'), dataIndex: 'counterpartContactEmail' },
  { title: t('contract.seller'), dataIndex: 'seller' },
  { title: t('contract.contractSeller'), dataIndex: 'contractSeller' },
  { title: t('contract.contractTime'), dataIndex: 'contractTime' },
  { title: t('contract.counterpartContractTime'), dataIndex: 'counterpartContractTime' },
  { title: t('contract.contractCreateTime'), dataIndex: 'contractCreateTime' }
])
const fetch = () => {
  if (route.query.cosId || route.query.arkCode) {
    queryContractDetail({
      arkCode: route.query.arkCode,
      cosId: route.query.cosId
    }).then((res) => {
      data.value = res.data
    })
  }
}
const viewPdf = (data: ContractItem) => {
  if (data.fileUrl) {
    const eleLink = document.createElement('a')
    eleLink.download = data.fileUrl
    eleLink.style.display = 'none'
    eleLink.href = data.fileUrl
    document.body.appendChild(eleLink)
    eleLink.click()
    document.body.removeChild(eleLink)
  } else {
    DcMessage.warning(t('tips.noContract'))
  }
}
// 修改合同编码
const showEditModal = (data: ContractItem) => {
  editForm.value = {
    ...data,
    newContractCode: undefined
  }
  visible.value = true
}
const updateCode = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { id, newContractCode } = editForm.value
    contractCodeUpdate({
      id,
      contractCode: newContractCode
    })
      .then((res) => {
        visible.value = false
        DcMessage.success(t('tips.K9PBK8'))
        fetch()
      })
      .finally(() => {
        loading.value = false
      })
  })
}
onMounted(() => {
  fetch()
})
</script>
